import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { CircularProgress, Tooltip, Select, MenuItem, FormControl, FormLabel, InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../services/http';
import { ContextSession } from "../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Menu } from '@mui/material';


async function getSolicitudes(accesos, ip) {
    let json = { data: "null" };
    let url = ip + "/api/resumen/";
    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    return datas;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'var(--color-brand-secondary)',
        color: 'var(--color-white)',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

// CSS para los botones de acción
const actionButtonsCSS = `
    .action-buttons {
        display: flex;
        gap: 20px;
    }

    .action-buttons a:hover {
        opacity: 0.7; //Cambia la opacidad al pasar el cursor 
        cursor: pointer;  Cambia el cursor al pasar sobre los botones 
    }
`;

function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, options, ...other } = props;
    const [value, setValue] = useState(valueProp);
    const radioGroupRef = React.useRef(null);

    useEffect(() => {
        if (!open) {
            setValue(valueProp);
            setValue(null); // Resetear el valor del RadioGroup al cerrar el diálogo
        }
    }, [valueProp, open]);


    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };
}

ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
};

function AsignarSolicitudes() {
    let sessi = useContext(ContextSession);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogUser, setDialogUser] = useState(null); // Estado para controlar el usuario seleccionado en el Dialog
    const [error, setError] = useState('');

    useEffect(() => {
        async function fetchUsers() {
            try {
                const response = await fetch(`${sessi.ip}/api/auth/oficiales`);
                const data = await response.json();
                setUsers(data);
            } catch (fetchError) {
                console.error('Error al obtener usuarios:', fetchError);
                setUsers([]);
            }
        }
        fetchUsers();
    }, [sessi.ip]);

    const handleConfirmDialogOpen = () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmDialogClose = (confirm) => {
        setOpenConfirmDialog(false);
        if (confirm) {
            handleConfirmAssign();
        }
    };


    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        if (!dialogUser) {
            setError('Debe seleccionar un usuario.');
            return;
        }
        setOpenDialog(false);
        const selected = users.find(user => user.id === parseInt(dialogUser, 10));
        setSelectedUser(selected);
        setOpenConfirmDialog(true); // Abrir el diálogo de confirmación
    };



    const handleConfirmAssign = () => {
        // Lógica para confirmar la asignación del usuario
        console.log('Usuario asignado:', selectedUser);
        setOpenDialog(false);
    };

    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [filas, setFilas] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const token = sessi.sessionData.token;
                const data = await getSolicitudes(token, sessi.ip);
                setFilas(data);
            } catch (fetchError) {
                console.error('Error al obtener datos:', fetchError);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [sessi.ip, sessi.sessionData.token]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/Participante/Solicitudes');
    };

    const handleClickCarga = (id) => {
        sessi.setVariable("SolicitudPrestamo", id);
        navigate(`/Participante/SolicitudesCarga`);
    };

    const handleSearchChange = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);
    };

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const filteredRows = filas.filter((row) => {
        const status = row.asignado === true ? 'Asignado' : 'Sin Asignar';

        return (
            (row.TipoPrestamo?.includes(loanType) || loanType === '') &&
            (status.includes(statusFilter) || statusFilter === '') &&
            (
                searchTerm === '' ||
                (searchTerm && (
                    row.NumeroSolicitud?.toString().includes(searchTerm) ||
                    (row.solicitante && row.solicitante[0] && (row.solicitante[0].Nombres?.toLowerCase().includes(searchTerm) || row.solicitante[0].Apellidos?.toLowerCase().includes(searchTerm)))
                ))
            )
        );
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [filterType, setFilterType] = useState('');

    const handleFilterClick = (event, type) => {
        setAnchorEl(event.currentTarget);
        setFilterType(type);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setFilterType('');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <Dialog
                        open={openDialog}
                        onClose={() => setOpenDialog(false)}
                        sx={{
                            '& .MuiDialog-paper': {
                                width: '40%', // Ajusta el ancho del diálogo
                                maxWidth: 'none', // Evita que el diálogo tenga un ancho máximo predeterminado
                            },
                        }}
                    >
                        <DialogTitle textAlign={'center'}>Seleccionar Usuario</DialogTitle>
                        <DialogContent dividers sx={{ display: 'flex', justifyContent: 'center' }}>
                            <RadioGroup
                                aria-label="users"
                                name="users"
                                value={dialogUser}
                                onChange={(event) => {
                                    setDialogUser(event.target.value);
                                    setError(''); // Limpiar el mensaje de error al seleccionar un usuario
                                }}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start', // Alinea los elementos al inicio del contenedor
                                }}
                            >
                                {users.map((user) => (
                                    <FormControlLabel
                                        value={user.id.toString()}
                                        key={user.id}
                                        control={<Radio color="error" variant="solid" />}
                                        label={user.nombre}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center', // Alinea el radio y el texto verticalmente
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                            {error && (
                                <Typography color="error" variant="body2">
                                    {error}
                                </Typography>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenDialog(false)}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'var(--color-surface-muted)',
                                    color: 'var(--color-black)',
                                    marginRight: 1,
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'var(--color-white)',
                                    },
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleDialogClose}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'var(--color-surface-muted)',
                                    color: 'var(--color-black)',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'var(--color-white)',
                                    },
                                }}
                            >
                                Asignar
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog open={openConfirmDialog} onClose={() => handleConfirmDialogClose(false)}>
                        <DialogTitle>Confirmar Asignación</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                ¿Está seguro de asignar la solicitud al usuario {selectedUser ? selectedUser.nombre : ''}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleConfirmDialogClose(false)} variant="contained"
                                sx={{
                                    backgroundColor: 'var(--color-surface-muted)',
                                    color: 'var(--color-black)',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'var(--color-white)',
                                    },
                                }}>
                                No
                            </Button>
                            <Button onClick={() => handleConfirmDialogClose(true)} variant="contained"
                                sx={{
                                    backgroundColor: 'var(--color-surface-muted)',
                                    color: 'var(--color-black)',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'var(--color-white)',
                                    },
                                }}>
                                Sí
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Asignar Solicitudes</b></h2>
                    </div>
                    <div className="row" style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell style={{ textAlign: 'center' }}>#</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>No. Solicitud</strong>
                                                <Tooltip title="Buscar por Solicitud" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'var(--color-white)' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Nombre del Solicitante</strong>
                                                <Tooltip title="Buscar por Nombre" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'var(--color-white)' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Tipo De Préstamo</strong>
                                                <Tooltip title="Filtrar por Tipo" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'loanType')}>
                                                        <FilterListIcon style={{ color: 'var(--color-white)' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Fecha Solicitud</strong>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Estado</strong>
                                                <Tooltip title="Filtrar por Estado" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'status')}>
                                                        <FilterListIcon style={{ color: 'var(--color-white)' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Acciones</strong>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleFilterClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    {filterType === 'search' && (
                                        <TextField
                                            placeholder="Realizar Búsqueda"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    {filterType === 'loanType' && (
                                        <FormControl>
                                            <Select
                                                value={loanType}
                                                onChange={handleLoanTypeChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos los tipos</em></MenuItem>
                                                <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                                                <MenuItem value="Con Aval">Con Aval</MenuItem>
                                                <MenuItem value="Consolidacion de Deuda">Consolidacion de Deuda</MenuItem>
                                                <MenuItem value="Alivio de Deuda">Alivio de Deuda</MenuItem>
                                                <MenuItem value="Refinanciamiento">Refinanciamiento</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'status' && (
                                        <FormControl>
                                            <Select
                                                value={statusFilter}
                                                onChange={handleStatusChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Asignar">Sin Asignar</MenuItem>
                                                <MenuItem value="Asignado">Asignado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                </Popover>
                                <TableBody>
                                    {filteredRows.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : filteredRows
                                        ).map((row) => (
                                            <StyledTableRow key={row.SolicitudID}>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.SolicitudID !== null && row.SolicitudID !== undefined && row.SolicitudID}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.NumeroSolicitud !== null && row.NumeroSolicitud !== undefined && row.NumeroSolicitud}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.solicitante && row.solicitante[0] && row.solicitante[0].Nombres && row.solicitante[0].Apellidos && `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.TipoPrestamo !== null && row.TipoPrestamo !== undefined && row.TipoPrestamo}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.FechaSolicitud !== null && row.FechaSolicitud !== undefined && row.FechaSolicitud.slice(0, 10)}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.asignado === true ? 'Asignado' : 'Sin Asignar'}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <button onClick={handleOpenDialog} title="Asignar Usuario" style={{ color: 'var(--color-gray-500)', margin: '0 1px', background: 'none', border: 'none', cursor: 'pointer' }}>
                                                            <i className="material-icons">group_add</i>
                                                        </button>
                                                    </div>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={8} style={{ textAlign: 'center' }}>
                                                No se encontraron datos
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {filteredRows.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredRows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default AsignarSolicitudes;


